import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-bir-replace-modal',
  templateUrl: './bir-replace-modal.component.html',
  styles: [
  ],
  standalone: false
})
export class BirReplaceModalComponent implements OnInit {

  visible = false;
  data: any = {};
  @Output() readonly selectBir: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
    return;
  }

  show(data: any) {
    this.data = data;
    this.visible = true;
  }

  concatString(stringValues: string[]) {
    return stringValues.filter(x => x).join(' ');
  }

  handleOk() {
    this.visible = false;
    this.selectBir.emit(this.data);
  }
}
